import React from 'react';

const Spacer = ({ size }) => {
  return <div style={{ marginBottom: size }} />;
};

export default Spacer;
